module.exports = __webpack_public_path__ + "media/app_stores/app_store2x-19addfde.png";